class CartAddons {
  constructor() {
    this.roots = document.querySelectorAll('[data-cart-addons-root]');
    if (!this.roots.length) return;

    this.bindEvents();
  }

  bindEvents() {
    this.roots.forEach((root) => {
      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-addon-variant-select]');
        if (!select) return;

        const card = select.closest('.cart-addon-card');
        const button = card?.querySelector('[data-cart-addon-add]');
        const priceBox = card?.querySelector('[data-addon-price]');

        if (!button) return;

        const selectedOption = select.options[select.selectedIndex];
        button.dataset.variantId = selectedOption.value;

        if (priceBox && selectedOption.dataset.price) {
          priceBox.textContent = selectedOption.dataset.price;
        }
      });

      root.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-cart-addon-add]');
        if (!button) return;

        event.preventDefault();

        const card = button.closest('.cart-addon-card');
        const statusBox = card?.querySelector('[data-cart-addon-status]');
        const variantId = button.dataset.variantId;
        const productTitle = button.dataset.productTitle || '商品';

        if (!variantId) {
          this.setStatus(statusBox, 'バリエーションを選択してください。', true);
          return;
        }

        button.disabled = true;
        button.classList.add('loading');
        this.setStatus(statusBox, '追加中…', false);

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1
                }
              ]
            })
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData?.description || 'カートへの追加に失敗しました。');
          }

          await response.json();

          this.setStatus(statusBox, `${productTitle} をカートに追加しました。`, false);

          // Dawn系: カートドロワーがある場合はセクション再描画、なければリロード
          await this.refreshCartUI();
        } catch (error) {
          this.setStatus(statusBox, error.message || 'エラーが発生しました。', true);
        } finally {
          button.disabled = false;
          button.classList.remove('loading');
        }
      });
    });
  }

  setStatus(target, message, isError = false) {
    if (!target) return;
    target.textContent = message;
    target.classList.toggle('is-error', isError);
  }

  async refreshCartUI() {
    const cartItemsContainer = document.querySelector('cart-items');
    const cartDrawer = document.querySelector('cart-drawer');

    // cart drawer があるテーマ向けの軽い再描画
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await response.json();
      cartDrawer.renderContents({ cartData: cart });
      return;
    }

    // cart page は簡易的にリロード
    if (cartItemsContainer) {
      window.location.reload();
      return;
    }

    // どちらでもない場合
    window.location.reload();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CartAddons();
});